import { render, staticRenderFns } from "./LoginError.vue?vue&type=template&id=570b7bf7&"
import script from "./LoginError.vue?vue&type=script&lang=ts&"
export * from "./LoginError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports